import {
    Card,
    Display,
    List
} from "stentor-models";

/**
 * Is the Display a Card
 * 
 * @privateRemarks We don't want to include stentor-response as a dependency so we are redefining them.  
 * @param display 
 * @returns 
 */
export function isCard(display: Display): display is Card {
    return !!display && (display as Card).type === "CARD";
}

/**
 * Is the Display a List
 * 
 * @privateRemarks We don't want to include stentor-response as a dependency so we are redefining them.  
 * @param display 
 * @returns 
 */
export function isList(display: Display): display is List {
    return !!display && ((display as List).type === "LIST" || (display as List).type === "CAROUSEL");
}